/**
    商品列表
**/
<template>
        <div class="rightaside_content">
          <h3 class="headerTitle">订单详情</h3>
          <!-- <div>{{orderInfoList.asOid}}</div> -->
          <div class="headerButton">
              <span style="line-height: 28px;">退单号：<i>{{orderInfoList.asOid||'--'}}</i></span>
              <div>
                    <el-button v-if="orderInfoList.status<13" size="mini" @click="cancleOrder(orderInfoList.bXyOasid)">取消退款</el-button>
                    <el-button v-if="orderInfoList.status==17&&orderInfoList.commodity.isRefund!=-1&&orderInfoList.bxysid!=-1" size="mini" @click="reApplyMoney">重新退款</el-button>
                    <el-button v-if="orderInfoList.status==17&&orderInfoList.commodity.isRefund!=-1&&orderInfoList.bxysid==-1" size="mini" @click="reApplyFee">重新退款</el-button>
            </div>
          </div>
          <el-divider></el-divider>
          <!-- 退单中 商品信息 -->
          <div>
              <el-row class="order_goods">
                    <el-col :span="2"> 
                         <el-image :src="`${orderInfoList.commodity.photos}`">
                              <div slot="error" class="image-slot">
                                  <i class="el-icon-picture-outline"></i>
                              </div>
                          </el-image>
                    </el-col> 
                    <el-col :span="16" class="order_Info_item">
                        <!-- <p>{{orderInfoList.commodity.name}} {{goodsItem.specificationlist[0].name}}</p> -->
                        <div>{{orderInfoList.commodity.name}} <p style="color:#ff6700">{{orderInfoList.commodity.specificationlist.length>0?orderInfoList.commodity.specificationlist[0].attributeContent||'默认规格':'默认规格'}}</p></div>
                        <p v-if="orderInfoList.bxysid!=-1">{{orderInfoList.commodity.realprice||orderInfoList.commodity.price}} 元 * {{orderInfoList.commodity.number || 1}}</p>
                        <p v-if="orderInfoList.bxysid==-1">{{orderInfoList.refundAmount||0}} 元 * {{orderInfoList.commodity.number || 1}}</p>
                    </el-col>

                    <!-- 买家已付款了 退款按钮 -->
                    <el-col :span="4" class="order_Info_item">
                        <!-- 没有物流 先按交易成功算 -->
                        <el-button class="reBackMoney" v-if="orderInfoList.status==2||orderInfoList.status==3?true:false" size="mini" @click="reBackMoney(goodsItem)">退款</el-button>
                        <!-- 没有物流 后期打开 -->
                        <!-- <el-button class="reBackMoney" v-if="orderInfoList.status==2?true:false" size="mini" @click="reBackMoney(goodsItem)">退款</el-button> -->
                    </el-col>  
                </el-row>
          </div>

          <!-- 退款信息 部分-->
          <div v-if="isRefund?true:false">
              <!-- 退款信息 -->
              <el-row class="order_goods">
                    <el-col :span="24" class="info_title">退款信息</el-col> 
                    <el-col :span="24"  class="info_content">
                        <p>退款编号： {{orderInfoList.asOid}}</p>
                        <p>申请时间： {{orderInfoList.createTime}}</p>
                        <p>退款原因： {{reasonType(orderInfoList.reason)}}</p>
                        <p>退款总额： {{orderInfoList.refundAmount}}</p>
                        <p>备注： {{orderInfoList.remarks || '--'}}</p>
                    </el-col>                             
                </el-row>
                <!-- 商家退款处理 -->
                 <el-row class="order_goods">
                    <el-col :span="24" class="info_title">商家退款处理</el-col> 
                    <!-- <el-col :span="24"  class="info_content">
                        <p>审核状态： {{orderStatus(orderInfoList.status)}}</p>
                    </el-col> -->
                    <el-col :span="24"  class="info_content" v-if="orderInfoList.status==11">
                        <p class="orderStatus">请等待商家处理</p>
                        <p v-if="restShow"> 还剩{{rest}}</p>
                    </el-col>
                     <el-col :span="24"  class="info_content" v-if="orderInfoList.status==12">
                        <p >商家已同意，请<i class="orderStatus" style="cursor:pointer" @click="editTransport(orderInfoList)">填写物流单号</i></p>
                        <p v-if="restShow"> 还剩{{rest}}</p>
                    </el-col>   
                    <el-col :span="24"  class="info_content" v-if="orderInfoList.status==13&&orderInfoList.returnDelivery">
                        <p>等待商家确认收货 </p>
                        <p v-if="(orderInfoList.status>=13||orderInfoList.status<=16)&&orderInfoList.returnType!=2">退货物流: <i class="orderStatus" @click="getTranspotInfo">{{orderInfoList.deliveryName}}（{{orderInfoList.returnDelivery}}）</i></p>
                        <p v-if="restShow"> 还剩{{rest}}</p>
                    </el-col>
                    <el-col :span="24"  class="info_content" v-if="orderInfoList.status==14&&orderInfoList.returnDelivery">
                        <p>等待商家退款 </p>
                        <p v-if="(orderInfoList.status>=13||orderInfoList.status<=16)&&orderInfoList.returnType!=2">退货物流: <i class="orderStatus" @click="getTranspotInfo">{{orderInfoList.deliveryName}}（{{orderInfoList.returnDelivery}}）</i></p>
                        <p v-if="restShow"> 还剩{{rest}}</p>
                    </el-col>
                     <el-col :span="24"  class="info_content" v-if="orderInfoList.status==17">
                        <p class="orderStatus">商家拒绝了你的退款申请： <i>{{orderInfoList.remark}}</i></p>
                        <p v-if="orderInfoList.commodity.isRefund!=-1">您可以修改申请，商家会重新处理</p>
                        <p v-if="orderInfoList.commodity.isRefund==-1">重新申请次数已用尽</p>
                    </el-col>
                    <el-col :span="24"  class="info_content" v-if="orderInfoList.status==18">
                        <p class="orderStatus">退款关闭</p>
                    </el-col>   
                    <el-col :span="24"  class="info_content" v-if="orderInfoList.status==14&&!orderInfoList.returnDelivery">
                        <p class="orderStatus">等待商家确认退款</p>
                    </el-col>
                    <el-col :span="24"  class="info_content" v-if="orderInfoList.status==16">
                        <p class="orderStatus">退款成功</p>
                        <p v-if="(orderInfoList.status>=13||orderInfoList.status<=16)&&(orderInfoList.returnType!=2&&orderInfoList.returnType)">退货物流: <i class="orderStatus" @click="getTranspotInfo">{{orderInfoList.deliveryName}}（{{orderInfoList.returnDelivery}}）</i></p>
                        <p>{{orderInfoList.updateTime}}</p>
                    </el-col>
                    <!-- 填写物流 -->
                    <el-col :span="24"  class="info_content openTransportForm" v-if="openTransportForm">
                         <el-form  :rules="rules" ref="sizeForm" :model="sizeForm" label-width="80px" size="mini" >
                            <el-form-item label="物流公司"  prop="company">
                                <el-select v-model="sizeForm.company" placeholder="请选择">
                                    <el-option v-for="item in expressList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="物流单号"  prop="companynumber">
                                <el-input v-model="sizeForm.companynumber"></el-input>
                            </el-form-item>
                            <el-form-item label="联系电话"  prop="phone">
                                <el-input v-model="sizeForm.phone"></el-input>
                            </el-form-item>
                            <el-form-item size="large">
                               <el-button type="primary" @click="submitTransport" size="mini" class="buttonBgd">提交</el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>   
                    <el-col :span="24"  class="info_content" v-if="(orderInfoList.status>=13||orderInfoList.status<=16)&&orderInfoList.returnDelivery">
                        <el-col :span="24" >
                            <el-collapse  accordion class="getLogistics">
                                <el-collapse-item title="查看物流" name="1">
                                    <el-steps direction="vertical" :active="1" v-if="deliver.length>0">
                                        <el-step icon="el-icon-position" v-for="(deliverItem,index) in  deliver" :key="index" :title="deliverItem.ftime" :description="deliverItem.context"></el-step>
                                    </el-steps>
                                    <div v-else style="text-align: center;">{{getTranspotMessage}}</div>
                                </el-collapse-item>
                            </el-collapse>
                        </el-col> 
                    </el-col>                   
                </el-row>
                


                <el-row class="footer_total">
                    <el-col :span="20">
                        <p>申请金额:</p>
                    </el-col>
                    <el-col :span="4"  class="footer_total_money">
                        <p class="finalTotal">{{orderInfoList.refundAmount||0}} 元</p>
                    </el-col>                             
                </el-row>
          </div>

        </div>
</template>
<script>
import {editbackMoney,getCompany,kuaidi100,cancleOrderItem,removeOrderItem,getDictData,remove_after_sale,backMoneyList,returnDelivery,getAllCompany} from '@/api/xunyou'
export default {
  data() {
    return {
        userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
        isRefund:0,
        iscancle:false, 
        openTransportForm:false,
        openTransportInfo:false,
        restShow:false,
        getTranspotMessage:'',
        rest:'',//时间
        logistics_code:'',
        deliver:[],
        reasaonList:[],
        returnOrder:'',//退款订单号
        orderInfoList:{},
        expressList:[],
        sizeForm:{
            company:'',
            companynumber:'',
            phone:'',
        },
        rules: {
            company: [{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            companynumber:[ { required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            phone:[{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],        
        },

        // orderInfoList:JSON.parse(sessionStorage.getItem("orderDetail")) || [],
    }
  },
  // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},
  mounted(){
      if(this.$route.fullPath.indexOf('refund')>0){
          this.isRefund =this.$route.query.refund
      }
      if(this.$route.fullPath.indexOf('returnOrder')){
          this.returnOrder = this.$route.query.returnOrder
      }
      this.backReason()
      this.getbackMoneyList()

  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
     //   查询退款详情 （列表）
    getbackMoneyList(){
         backMoneyList({
            uid: this.userInfo.userId,
            asOid: this.returnOrder,
            bXyOasid:this.$route.query.bXyOasid||'',
        }).then(res => {
              if (res.code == 0) {
                  this.orderInfoList = res.rows[0]
                  this.getCompanyLog()
                    if(this.orderInfoList.status<16){
						setInterval(() => {
							this.orderInfoList.returnTime=this.orderInfoList.returnTime.replace(/-/g,'/');
							var waitConfirm = (new Date(this.orderInfoList.returnTime).getTime())-1000*24*60*60*7
                            var rest=waitConfirm-(new Date().getTime())
                            // debugger
							if(rest>0){
								this.restShow=true
							}else{
								this.restShow=false
							}
							var day= Math.floor(rest/1000/60/60/24)
							var hour= Math.floor(rest/1000/60/60%24)
							var minute= Math.floor(rest/1000%3600/60)
							if(day!==0&hour!==0){
								rest=day+'天'+hour+'小时'+minute+'分钟'
							}else if(day==0&hour!==0){
								rest=hour+'小时'+minute+'分钟'
							}else{
								rest=minute+'分钟'
							}
							this.rest=rest
						}, 1000)
					}

              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
        }) 
    },

    //   查询退款原因
    backReason(){
         getDictData({
             key:'b_xy_deal_after_sale_reason'
        }).then(res => {
              if (res.code == 0) {
                  if(res.data.length>0){
                      this.reasaonList = res.data
                  }
                  
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
        }) 
    },

    // 退款原因转换
    reasonType(type){
        let reason = ''
        this.reasaonList.forEach((item)=>{
            if(item.dictValue == type){
                reason = item.dictLabel
            }
        })
        return reason
    },

      //   订单状态转换
    orderStatus(status){
        switch(status) {
            case 11:
                return '提交退单'
                break;
            case 12:
                 return '退单审核'
                break;
            case 13:
                 return '收货确认'
                break;
            case 14:
                 return '退款确认'
                break;
            case 15:
                 return '收款确认'
                break;
            case 16:
                 return '完成'
                break;
            case 17:
                 return '已拒绝退款'
                break;
            case 18:
                 return '已取消'
                break;
            default:                
                return '--'
        } 
    },


      //   撤销退款申请
     cancleOrder(orderId) {
        this.$confirm('确定取消订单?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
             remove_after_sale({
                 ids: orderId
             }).then(res => {
              if (res.code == 0) {
                this.$message({
                    type: 'success',
                    message: '取消成功!'
                });
                setTimeout(()=>{
                    this.$router.push('/refund')
				},500)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('取消失败，请稍后再试！')
            })          
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });          
        });
      },

    //   邮费重新申请
    reApplyFee(){
            const req = {
                bXyOasid:this.orderInfoList.bXyOasid,
                remarks:this.orderInfoList.remarks, // 退款说明
                createTime:new Date().getTime(),//有值时，说明是重新申请
           }
         editbackMoney(req)
            .then(res => {
                if(res.code == 0){
                    this.$router.push('/refund')
                     this.$message({
                        type: 'success',
                        message: '申请成功'
                    });
                }else{
                    this.msg = res.msg
                }
            })
            .catch(err => {
              this.$message.error('提交失败，请稍后再试！')
            })
    },

    // 重新退款
      reApplyMoney(){
          const myRefundInfo = {
                oid:this.orderInfoList.oid,
                bXyOasid:this.orderInfoList.bXyOasid,
                returnType:this.orderInfoList.status<=2?2:1,//1：需要退货，2.不用退货。 是否需要退货 没发货之前不需要退货
                orderNumber:this.orderInfoList.orderNumber,
                amount:this.orderInfoList.amount,
                goodsItem:this.orderInfoList.commodity,
            }
            sessionStorage.setItem('myRefundInfo',  JSON.stringify(myRefundInfo))
            this.$router.push('/myRefund?status=2')
      },

    // 退款
    reBackMoney(goodsItem){
        const myRefundInfo = {
            orderNumber:this.orderInfoList.orderNumber,
            goodsItem
        }
        console.log(myRefundInfo,'退库随你啦')
        sessionStorage.setItem('myRefundInfo',  JSON.stringify(myRefundInfo))
        this.$router.push('/myRefund')

    },
    // 查询某个快递公司
     getCompanyLog(){
         if(this.orderInfoList.deliveryCompany){
              getCompany({id:this.orderInfoList.deliveryCompany}).then(res=>{
                if(res){
                    this.logistics_code = res.code;
                    this.getTranspot()
                }
                
            })
         }
       
    },
    //   物流查询
    getTranspot(){
         kuaidi100({
             // tracking_num:'4316785519105 ',
            tracking_num: this.orderInfoList.returnDelivery!=null?this.orderInfoList.returnDelivery:'78164982674324',
			logistics_name: this.logistics_code 
         }).then(res => {
             if(res.status == 200){
                 this.deliver = res.data||[]
             }else{
                 this.getTranspotMessage = res.message
             }
                
            }) 
    },

    // 查询物流公司
      getAllCompanyList(){
         getAllCompany().then(res => {
            if(res.code == 0){
				this.expressList=res.rows
			}
        }) 
    },
    // 打开填写物流
    editTransport(item){
        this.openTransportForm = true
        this.getAllCompanyList()
    },

    // 打开物流信息
    getTranspotInfo(){
        this.openTransportInfo = true
        // this.getTranspot()
    },
    // 物流信息提交
    submitTransport(){
        this.$refs.sizeForm.validate((valid) => {
        if (valid) {//  this.$router.push('/myOrder')
            const req = {
                returnDelivery:this.sizeForm.companynumber,
				deliveryCompany:this.sizeForm.company,
				tel: this.sizeForm.phone,
				bXyOasid:this.orderInfoList.bXyOasid,
           }
         returnDelivery(req)
            .then(res => {
                if(res.code == 0){
                    this.$message({
                        type: 'success',
                        message: '提交成功'
                    })
                    this.openTransportForm = false
                    this.getbackMoneyList()
                }else{
                }
            })
            .catch(err => {
              this.$message.error('提交失败，请稍后再试！')
            })
          } 
      });
    },
  },
};
</script>

<style scoped lang="less">
    .rightaside_content{
        .el-divider--horizontal {
            display: block;
            height: 1px;
            width: 100%;
            margin: 5px 0;
        }
        .headerTitle{
            font-size: 20px;
            height: 40px;
            line-height: 40px;
            color: #666;
        }
        .headerButton {
            display: flex;
            justify-content: space-between;
            button.el-button.el-button--default.el-button--mini {
                // background: #ff6700;
                // color: white;
                background: #f896521a;
                color: #ff6700;
                border: 1px solid #ff6700;
            }
            .el-button.el-button--mini:focus, .el-button.el-button--mini:hover {
                background: #ff6700 !important;
                color: white !important;
            }
        }
        .order_goods.el-row {
            border-bottom: 1px solid#DCDFE6;
            padding: 20px;
            box-sizing: border-box;
            .order_Info_item {
                margin-left: 10px;
            }
        }
        .info_title{
            margin: 0 0 15px;
            font-size: 16px;
            font-weight: 400;
            color: #333;
        }
        .info_content{
                color: #757575;
                p{
                    margin-bottom: 4px;
                }
        }
        .footer_total{
                text-align: right;
                color: #757575;
                p{
                    margin: 10px 0;
                }
                .footer_total_money{
                    color: #ff6700;
                    .finalTotal{
                        font-size: 20px;
                    }
                }
                
        }
       button.el-button.reBackMoney.el-button--default.el-button--mini {
            background: #ff674c;
            color: white;
            border: 1px solid #ff674c;
        }
        button.el-button.reBackMoney.el-button--default.el-button--mini:hover {
            background: #f896521a;
            color:  #ff674c;
            border: 1px solid #ff674c;
        }
        .orderStatus{
            color:#ff674c;
        }
        .openTransportForm{
            margin: 20px;
        }

        // 查看物流
    .getLogistics{
       border-top:0px !important;
       border-bottom:0px !important;
       /deep/.el-collapse-item__header{
           border-bottom:0px !important;
           height:auto;
           line-height: inherit;
           color: coral;
           cursor: pointer;
           display:inline-block;
            margin: 10px 0;
       }
       /deep/.el-collapse-item__wrap{
           border-bottom:0px !important;
       }
       /deep/.el-step__icon{
           height: auto;
       }
       /deep/.el-step__icon-inner[class*=el-icon]:not(.is-status){
               font-size: 10px;
       }
       /deep/.el-step.is-vertical .el-step__title{
            line-height: inherit;
            margin-top: 10px;
            font-weight: bold;
       }
       /deep/.el-step.is-vertical .el-step__icon.is-icon {
            margin-top: 20px;
        }
        /deep/.el-step__title.is-process, /deep/.el-step__description.is-process{
                color: #C0C4CC;
        }
    }

    }

</style>

 
 

 


// WEBPACK FOOTER //
// src/views/myOrder/refundDetail.vue